<template>
  <div class="public-content role-manage">
    <div class="breadcrumb">管理员维护</div>
    <div class="querybox" style="background:#fff">
      <div class="inputbox">
        <el-form ref="form" style="margin-top:20px;" inline :model="form" label-width="80px">
          <el-form-item label="手机号:">
            <el-input v-model="inputInfo.phone" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="姓名:">
            <el-select clearable v-model="inputInfo.fullName" :filter-method="selectUserList" filterable placeholder="请输入用户名查询">
              <el-option v-for="item in userList" :key="item.id" :label="item.fullName" :value="item.fullName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属角色:">
            <el-select v-model="inputInfo.roleName" placeholder="请选择" clearable>
              <el-option v-for="item in filteredRoleNameList" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="注册日期:">
            <el-date-picker
              class="datepicker"
              v-model="value1"
              format='yyyy-MM-dd'
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item> -->
        </el-form>
      </div>
      <el-button type="primary" @click="queryInfo.pageNum = 1, query()" round>查询</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="roleList" border style="width: 100%">
          <el-table-column prop="phone" label="手机号" min-width="180">
            <template slot-scope="scope">
              <!-- <span @click="$router.push({path:'/adminorder',query:{id:scope.row.id}})" class="color-blue">{{scope.row.phone}}</span> -->
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fullName" label="姓名" min-width="180">
          </el-table-column>
          <el-table-column label="所属角色" min-width="180">
            <template slot-scope="scope">
              <span v-if="$hasPermission('crm:admin:user:doAssign')">{{ scope.row.roleName }}</span>
              <span v-else @click="aaa(scope)" class="color-blue">{{ scope.row.roleName }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <CombinedDialog ref="dialogRef" @addMember="addMember"></CombinedDialog>
    <!-- 角色设置 -->
    <el-dialog :close-on-click-modal="false" title="角色设置" :visible.sync="dialogVisible" width="30%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="角色：">
          <el-select v-model="form.selectRole" placeholder="请选择">
            <el-option v-for="item in roleNameList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index'
import { userGetUserList, roleUpdateStatus, userGetAdminList, getAdminByFullName, getAllUsersByFullName, userDoAssign, getRoleName } from '@/api/crm'
export default {
  name: 'role-manage',
  components: {
    CombinedDialog,
    VPagination
  },
  data () {
    return {
      filteredRoleNameList: [],
      userList: [],
      value1: null,
      lock: true,
      form: {
        selectRole: ''
      },
      roleNameList: [],
      dialogVisible: false,
      nowRole: '',
      inputInfo: {
        roleName: '',
        fullName: '',
        phone: '',
        date: ''
      },
      roleList: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.getRoles(this.queryInfo)
    getRoleName({}).then(res => {
      if (res.data.success) {
        this.roleNameList = res.data.data
        this.filteredRoleNameList = res.data.data.filter(item => {
          return item.name !== '业务'
        })
      }
    })
  },
  methods: {
    aaa (scope) {
      this.dialogVisible = true
      this.nowRole = scope.row
      this.form.selectRole = this.filteredRoleNameList.find(item => {
        return item.name === scope.row.roleName
      }).id
    },
    selectUserList (val) {
      if (val.trim()) {
        getAdminByFullName(val).then(res => {
          if (res.data.success) {
            this.userList = res.data.data
          }
        })
      }
    },
    confirm () {
      if (!this.lock) { this.$message.warning('正在处理，请稍后'); return }
      this.lock = false
      userDoAssign({ roleId: this.form.selectRole, userId: this.nowRole.id }).then(res => {
        this.lock = true
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getRoles(this.queryInfo)
          this.dialogVisible = false
        }
      })
    },
    query () {
      this.getRoles(this.queryInfo)
    },
    getRoles (val) {
      userGetAdminList({
        pageNum: val.pageNum,
        pageSize: val.pageSize,
        adminVo: {
          fullName: this.inputInfo.fullName,
          roleName: this.inputInfo.roleName,
          phone: this.inputInfo.phone,
          registerTimeBegin: this.value1 === null ? '' : this.value1[0],
          registerTimeEnd: this.value1 === null ? '' : this.value1[1]
        }
      }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.roleList = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getRoles(this.queryInfo)
    },
    changeStatus (row) {
      roleUpdateStatus({ roleId: row.id, status: row.status }).then((res) => {
        if (res.data.success) {
        } else {
        }
      })
    },
    changeRole (item, row) {
      if (item === 0) {
        this.$refs.dialogRef.show('addMember', '添加成员', '', '', '', row.id)
      }
      if (item === 1) {
        this.$router.push({
          path: '/editroles',
          query: {
            id: row.id,
            set: 'edit'
          }
        })
      }
    },
    addRole () {
      this.$router.push({
        path: '/editroles',
        query: {
          set: 'add'
        }
      })
    },
    addMember () {
      this.getRoles(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="scss">
 .querybox {
   display: flex;
   height: 70px;
   align-items: center;
   padding: 0 40px;
   justify-content: space-between;
 
   span {
     font-family: "思源黑体 Bold", "思源黑体 Regular", "思源黑体 CN Regular", sans-serif;
     font-weight: 700;
     font-style: normal;
     font-size: 14px;
     text-align: right;
     line-height: 28px;
   }
 
   // .inputbox{
   //   display: flex;
   //   align-items: center;
   //   // input{
   //   //   font-family: "思源黑体 CN Light", "思源黑体 CN", sans-serif;
   //   //   font-size: 14px;
   //   //   font-weight: 300;
   //   //   font-style: normal;
   //   //   color: rgb(187, 187, 187);
   //   //   width: 180px;
   //   //   height: 30px;
   //   //   border-radius: 5px;
   //   //   outline: none;
   //   //   border: 1px solid #ccc;
   //   //   padding-left: 10px;
   //   //   margin-right: 50px;
   //   // }
   //   .datepicker{
   //     height: 25px;
   //     margin: 0;
   //     box-sizing: content-box;
   //     border: 1px solid #ccc;
   //   }
   // }
   // .select{
   //   width: 95px;
   //   height: 30px;
   //   border-radius: 30px;
   //   border:1px solid rgba(121, 121, 121, 1);
   // }
   // .select:hover{
   //   background: rgba(121, 121, 121, 1);
   //   color: #fff;
   // }
 }
 </style>
